import classNames from './DealErrorMessageContent.module.scss';
import SVG from 'react-inlinesvg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import helloBritannicaIcon from '@/assets/svg/hello_britannica.svg';

interface DealErrorMessageContentProps {
  title: string;
  description: string;
  buttonText: string;
}

const DealErrorMessageContent = ({
  title,
  description,
  buttonText,
}: DealErrorMessageContentProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleHomeClick = (text: string) => {
    navigate('/login');
  };
  return (
    <div className={classNames.DealErrorMessageContent}>
      <SVG src={helloBritannicaIcon} />
      <h2>{title}</h2>
      <p dangerouslySetInnerHTML={{ __html: description }} />
      <button className={classNames.btn} onClick={() => handleHomeClick(buttonText)}>
        {buttonText}
      </button>
    </div>
  );
};

export default DealErrorMessageContent;
